import get from 'lodash/get';

const NAMESPACE = 'desktop';

export const selectShouldShowDesktopUpdateBanner = (state) =>
  get(state, [NAMESPACE, 'shouldShowDesktopUpdateBanner']);
export const selectShowManualUpdateBanner = (state) =>
  get(state, [NAMESPACE, 'showManualUpdateBanner']);
